let hour = () => {
  let hour = []
  const prepend = (n) => {
    if (n < 10) {
      return `0${n}`
    } else {
      return `${n}`
    }
  }

  for(let i=0; i<=23; i++) {
    hour[i] = {
      text: `${prepend(i+1)}:00`,
      value: `${prepend(i+1)}:00`,
    }
  }

  return hour
}

export default hour




// WEBPACK FOOTER //
// ./src/lib/hour.js